import React from "react";
import { usePremissions } from "../../PremissionsProvider/PremissionsProvider";
import { IRoleBasedEmailRightPanelProps } from "./RoleBasedEmailRightPanel.types";
import { EmailComposeRightPanel } from "../../../components/MessagesDialogs/EmailCompose/EmailCompose";
import { Typography } from "@mui/material";

export const RoleBasedEmailRightPanel: React.FC<
  IRoleBasedEmailRightPanelProps
> = (props) => {
  let { emailAccess } = props;
  const { moduleKey: moduleId, history, objectvaraibles } = props;

  const { getPremissionsByModuleId } = usePremissions();
  const premissions = getPremissionsByModuleId(moduleId);

  emailAccess = emailAccess || premissions.send_mail;

  console.log("objectvaraibles1", objectvaraibles);

  if (emailAccess) {
    return (
      <EmailComposeRightPanel
        {...props}
        history={history}
        objectvaraibles={objectvaraibles}
      />
    );
  }

  return (
    <Typography variant="body1" marginLeft={1}>
      {props.displayLabel}
    </Typography>
  );
};

